import PropertiesTable from "./PropertiesTableContainer";

export default PropertiesTable;
